import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { navigateToDashboard } from '../../utils/roleNavigation';

/**
 * Pagina mostrata quando la risorsa richiesta non esiste (HTTP 404)
 */
const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    if (user) {
      navigateToDashboard(navigate, user.role);
    } else {
      navigate('/');
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row className="w-100">
        <Col md={8} lg={6} className="mx-auto">
          <Card className="shadow-lg border-0">
            <Card.Body className="text-center p-5">
              <div className="mb-4">
                <i className="bi bi-exclamation-triangle text-primary" style={{ fontSize: '5rem' }}></i>
              </div>
              
              <h1 className="display-4 fw-bold text-primary mb-3">404</h1>
              <h2 className="mb-4">Pagina Non Trovata</h2>
              
              <p className="text-muted mb-4">
                La pagina che stai cercando non esiste o è stata spostata.
              </p>

              {location.pathname && (
                <div className="alert alert-light mb-4">
                  <small className="text-muted">
                    <i className="bi bi-link-45deg me-2"></i>
                    Percorso richiesto: <code>{location.pathname}</code>
                  </small>
                </div>
              )}

              <p className="text-muted mb-4">
                Verifica l'URL o torna alla pagina principale per continuare.
              </p>

              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <Button variant="outline-secondary" onClick={handleGoBack}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Torna Indietro
                </Button>
                <Button variant="primary" onClick={handleGoHome}>
                  <i className="bi bi-house-door me-2"></i>
                  {user ? 'Vai alla Dashboard' : 'Vai alla Home'}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
